import React, { useEffect, useState } from 'react';
import usePortal from 'react-useportal';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks';
import { getCoords } from '../../../../utils';
import { Coords } from '../../../../types';
import { IObject } from 'types';
import { DisabledHouse } from '../../../../types';
import { SelectedItemMenu } from './selected-item-menu';
import { ItemWrapper, Wrapper } from './selected-item.styled';

interface IProps {
  item: IObject;
  disabledHouses?: DisabledHouse[];
}

export const SelectedItem = observer(({ item, disabledHouses }: IProps) => {
  const { fias } = useStore();
  const [open, setOpen] = useState<boolean>(false);
  const [coords, setCoords] = useState<Coords | null>(null);
  const { Portal, ref, isOpen, openPortal, closePortal } = usePortal({
    onClose: () => setOpen(false),
  });

  useEffect(() => {
    if (!open) {
      return;
    }

    if (ref.current) {
      const coords = getCoords(ref.current);
      setCoords(coords);
    }
  }, [open]);

  const handleOpenMenu = (): void => {
    if (!(item.houses && !item.title)) {
      return;
    }
    setOpen(true);
    openPortal();
  };

  const applyItems = (): void => {
    fias.setConfirmedSelectedHouses(fias.currentSelectedHouses);
    fias.setConfirmedSelectedFlats(fias.currentSelectedFlats);
    setOpen(false);
    closePortal();
  };

  return (
    <Wrapper ref={ref}>
      <ItemWrapper
        isClickable={item.houses && !item.title}
        onClick={handleOpenMenu}
      >
        <div>{item.name || item.title}</div>
        {!!item.selectedHouses?.length && (
          <div>
            {item.selectedHouses.length}/{item.houses?.length || 0}
          </div>
        )}
      </ItemWrapper>
      {isOpen && coords && (
        <Portal>
          <SelectedItemMenu
            item={item}
            coords={coords}
            applyItems={applyItems}
            closePortal={closePortal}
            disabledHouses={disabledHouses}
          />
        </Portal>
      )}
    </Wrapper>
  );
});
